import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// components
import AboutThumbnailComponents from "../../components/about/thumbnailComponents";
import SocialMediaComponents from "../../components/about/socialMediaComponents";
import QuoteTestimonyComponents from "../../components/about/quoteTestimonyComponents";
import DescribeMeComponents from "../../components/about/describeMeComponents";
import CurrentPositionComponent from "../../components/about/currentPositionComponent";
export default function Index() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <div>
      <div className={`about`}>
        {isMobile ? (
          // Mobile View
          <div className={`about_content`}>
            <AboutThumbnailComponents />
            <div className="row mt-5">
              <div className="col-12">
                <DescribeMeComponents />
                <CurrentPositionComponent />
              </div>
              <div className="col-12">
                <QuoteTestimonyComponents />
              </div>
              <div className="col-12">
                <SocialMediaComponents />
              </div>
            </div>
          </div>
        ) : (
          // Desktop View
          <div className={`about_content`}>
            <AboutThumbnailComponents />
            <div className="row mt-5">
              <div className="col-3">
                <SocialMediaComponents />
              </div>
              <div className="col-4">
                <DescribeMeComponents />
                <CurrentPositionComponent />
              </div>
              <div className="col-5">
                <QuoteTestimonyComponents />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
